import { toastr } from 'react-redux-toastr';

export const detectAdBlocker = () => {
  const head = document.getElementsByTagName('head')[0];

  // we will dynamically generate some 'bait'.
  const script = document.createElement('script');
  script.id = 'adblock-detection';
  script.type = 'text/javascript';
  script.src = '/ads.bundle.js';
  script.onerror = () => {
    toastr.warning('We have detected you\'re using an adblocker, some features may not be available until it is disabled.', { timeOut: 0 });
  };
  head.appendChild(script);
};
